export enum SupportedBiometryType {
    None = 0,
    Fingerprint = 1,
    Face = 2,
}
